import { capitalize } from "lodash";
import getClasses from "utils/getClasses";
import styles from "./ClientStatusTag.module.scss";

interface ClientStatusTagProps {
  status: "patient" | "waitlist" | "inactive" | "discharged";
}

const ClientStatusTag = ({ status }: ClientStatusTagProps) => {
  const getDisplayText = (status: string) => {
    switch (status) {
      case "patient":
        return "Active";
      default:
        return capitalize(status);
    }
  };

  return (
    <div
      className={getClasses(
        styles["client-status-tag"],
        styles[`client-status-tag--${status}`],
      )}
    >
      {getDisplayText(status)}
    </div>
  );
};

export default ClientStatusTag; 